// @ts-ignore
import React from "react"
import styled from "styled-components"
import { Text } from "./"

export default styled(Text).attrs(() => ({ textStyle: "headline" }))``
